module.exports = __webpack_public_path__ + "static/media/Roboto-Bold22.a2ba46b3.ttf";